const uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[1-7][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

export function isValidUUID(id) {
  return uuidRegex.test(id);
}
